import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { ImageSectionStyledAC } from './AC/ImageSectionStyled.AC';
import { ImageSectionStyledAP } from './AP/ImageSectionStyled.AP';
import { ImageSectionStyledDS } from './DS/ImageSectionStyled.DS';
import { ImageSectionStyledOV } from './OV/ImageSectionStyled.OV';
import { ImageSectionStyledOVGB } from './OV/GB/ImageSectionStyled.OVGB';
import { ImageSectionStyled } from './ImageSectionStyled';
import { SC } from '../../../styles/theme';

export type ImageSectionProps = SC & {
    isSummary?: boolean;
    isBasket?: boolean;
    isTrim?: boolean;
};

const ImageSection = (props: ImageSectionProps) => {
    if (BRAND === 'OV') return isMarketGB ? <ImageSectionStyledOVGB {...props} /> : <ImageSectionStyledOV {...props} />;
    if (BRAND === 'AC') return <ImageSectionStyledAC {...props} />;
    if (BRAND === 'AP') return <ImageSectionStyledAP {...props} />;
    if (BRAND === 'DS') return <ImageSectionStyledDS {...props} />;
    return <ImageSectionStyled {...props} />;
};

export default ImageSection;
